import { render } from "./BulkExportClaimsModal.vue?vue&type=template&id=b34236e4"
import script from "./BulkExportClaimsModal.vue?vue&type=script&lang=js"
export * from "./BulkExportClaimsModal.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./BulkExportClaimsModal.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_828d00b8%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fclaim%2FBulkExportClaimsModal.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__